export const SITE_INFO = {
  clinic: {
    name: "HopeSpring Medical Clinic",
    phone: "587-534-2506",
    phoneLink: "+15875342506",
    email: "info@hopespringmedical.ca",

    hours: {
      weekdays: "Monday – Friday: 9:00 AM – 5:00 PM",
      saturday: "Saturday: Closed",
      sunday: "Sunday & Holidays: Closed",
    },
  },

  pharmacy: {
    name: "HopeSpring Pharmacy",
    phone: "587-534-2504",
    phoneLink: "+15875342504",
    email: "hsskypharmacy@gmail.com",

    hours: {
      weekdays: "Monday – Friday: 9:00 AM – 6:00 PM",
      saturday: "Saturday: 10:00 AM – 2:00 PM",
      sunday: "Sunday & Holidays: Closed",
    },
  },

  address: {
    full: "151 Skyview Bay NE #2130, Calgary, AB T3N 2K3",
  },

  pharmacist: {
    name: "Shraddha Agarwal",
    designation: "Proprietor & Licensee Pharmacist",
    license: "ACP 13158",
    phone: "587-534-2504",
    email: "hsskypharmacy@gmail.com",
  },

  


  team: [

    /* { 
      id: 1,
      name: "Dr. Segun",
      credentials: "Family Physician",
      role: "Doctor",
      type: "doctor",
      bio: "Providing compassionate medical care with a focus on patient wellness, prevention, and ongoing family healthcare support.",
      focus: "Family medicine, preventive care, and patient wellness.",
      approach:
        "Clear communication, respectful care, and coordinated follow-up.",
    },*/ 
    {
      id: 2,
      name: "Dr. Yemisi",
      credentials: "Family Physician",
      role: "Doctor",
      type: "doctor",
      bio: "Supporting patients and families with professional, patient-centered medical care in a welcoming clinic environment.",
      focus: "Patient-centered care, family health, and long-term wellness.",
      approach: "Compassionate support and evidence-informed care.",
    },

    {
      id: 3,
      name: "Shraddha Agarwal",
      credentials: "Pharmacist, ACP 13158",
      role: "Proprietor & Licensed Pharmacist",
      type: "pharmacist",
      bio: "Shraddha Agarwal is the proprietor and licensed pharmacist at HopeSpring Pharmacy. She supports patients with safe medication use, prescription services, medication counselling, and personalized pharmacy care.",

      licenses: [
        "Proprietor: Shraddha Agarwal",
        "Licensee: Shraddha Agarwal (ACP 13158)",
        "Alberta College of Pharmacy Information Available",
      ],

      focus:
        "Medication counselling, prescription services, vaccinations, medication reviews, and pharmacy support.",

      approach:
        "Safe, professional, and patient-focused pharmacy care.",
    },
  ],
};